module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/json-loader/index.js!./en_PL.json"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?lazy!./src/i18n/languages/en_PL.json
// module id = 616
// module chunks = 39